import { inherits as _inherits, createClass as _createClass, assertThisInitialized as _assertThisInitialized } from '../_virtual/_rollupPluginBabelHelpers.js';
import { getSuper } from '../utils/getSuper.js';
import { HttpServerException } from '../base/HttpServerException.js';

var HttpVersionNotSupported = function (_HttpServerException) {
  _inherits(HttpVersionNotSupported, _HttpServerException);
  function HttpVersionNotSupported(msgOrParams) {
    var _this;
    var name = 'HttpVersionNotSupported';
    _this = _HttpServerException.call(this, 505, getSuper(name, msgOrParams)) || this;
    Object.setPrototypeOf(_assertThisInitialized(_this), HttpVersionNotSupported.prototype);
    _this.name = name;
    return _this;
  }
  return _createClass(HttpVersionNotSupported);
}(HttpServerException);
HttpVersionNotSupported.STATUS = 505;

export { HttpVersionNotSupported };
